"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractCitations = extractCitations;
exports.normalizeTextPart = normalizeTextPart;
const conventions_1 = require("../../../conventions");
const json_1 = require("../../utils/json");
const reasoning_1 = require("./reasoning");
/** Citation carriers are provider vocabulary (`citationKeys`); the first
 * non-empty carrier lifts verbatim into `providerMetadata.citations`. */
function extractCitations(value) {
    for (const provider of conventions_1.registeredProviders) {
        for (const key of provider.citationKeys ?? []) {
            const citations = (0, json_1.parseArray)(value[key]);
            if (citations && citations.length > 0)
                return (0, json_1.toJsonValue)(citations);
        }
    }
    return undefined;
}
/** Universal text block: OpenAI Responses `input_text`/`output_text` share
 * this shape with the generic `text` type; Gemini's typed thought flag is
 * checked the same way regardless of which of the three type strings matched. */
function normalizeTextPart(value) {
    const content = value.text ?? value.content;
    const text = (0, json_1.optionalString)(content) ?? "";
    if (value.thought === true) {
        return (0, reasoning_1.reasoningPart)(text, (0, json_1.optionalString)(value.thoughtSignature ?? value.thought_signature));
    }
    // LiteLLM+OpenAI Instrumentation may store parsed JSON in a text block's payload.
    if (content !== undefined &&
        content !== null &&
        typeof content !== "string") {
        const providerMetadata = (0, json_1.toProviderMetadata)((0, json_1.omitKeys)(value, [
            "type",
            "text",
            "content",
            "providerMetadata",
            "providerOptions",
        ]));
        return {
            type: "data",
            value: (0, json_1.toJsonValue)(content),
            ...(providerMetadata ? { providerMetadata } : {}),
        };
    }
    const citations = extractCitations(value);
    return {
        type: "text",
        text,
        ...(citations ? { providerMetadata: { citations } } : {}),
    };
}
